// extracted by mini-css-extract-plugin
module.exports = {"work":"work_work__u8U_1","links":"work_links__61HCg"};